import { api } from "@/lib/api";

/**
 * Wire-format mirror of `arr_api::onboarding::OnboardingStatus`. The
 * `missing_steps` IDs are stable strings — see the Rust module for the
 * canonical list. Today: `tmdb_key`, `library_paths`, `indexer`,
 * `download_client`.
 */
export interface OnboardingStatus {
  needs_setup: boolean;
  completed_at: string | null;
  missing_steps: string[];
}

export const onboardingApi = {
  status: () => api<OnboardingStatus>("/api/v1/onboarding/status"),
  /**
   * Stamps `onboarding.completed_at`. Used both by the "Done" step and
   * by "Skip wizard" — explicitly opting out is the same end-state as
   * finishing, so the wizard doesn't pop up again.
   */
  complete: () =>
    api<OnboardingStatus>("/api/v1/onboarding/complete", { method: "POST" }),
};
